<template>
  <div class="c-counter">
    <div class="left" @click="doCount(-1)">-</div>
    <div class="count">{{ value }}</div>
    <div class="right" @click="doCount(1)">+</div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-counter',
    props: {
      value: {
        type: Number,
        default: 1
      },
      minValue: {
        type: Number,
        default: 0
      },
      maxValue: {
        type: Number,
        default: 10000
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {
      doCount (step) {
        let nextValue = this.value + step
        if (nextValue >= this.minValue && nextValue <= this.maxValue) {
          this.$emit('input', nextValue)
        }
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?c22e0720